import { Link, Icon, HStack } from "@chakra-ui/react";
import { FiExternalLink } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BaseBlockProps } from "./types";

interface LinkContent {
  url?: string;
  text?: string;
}

export const LinkBlock = ({ block }: BaseBlockProps) => {
  const navigate = useNavigate();
  const content = block.content as LinkContent | string | undefined;

  const url = typeof content === "object" ? content?.url : block.url;
  const text = typeof content === "object" ? content?.text : (typeof content === "string" ? content : undefined);
  const displayText = text || url || "Link";

  if (!url) return null;

  // Check if the URL is internal
  const isInternalLink =
    url.startsWith("/") ||
    (!url.startsWith("http://") && !url.startsWith("https://"));

  const isExternal = url.startsWith("http://") || url.startsWith("https://");

  const handleClick = (e: React.MouseEvent) => {
    if (isInternalLink) {
      e.preventDefault();
      navigate(url);
    }
  };

  return (
    <Link
      href={url}
      onClick={isInternalLink ? handleClick : undefined}
      isExternal={isExternal}
      color="p.600"
      fontSize="sm"
      fontWeight="500"
      display="inline-flex"
      alignItems="center"
      gap={1}
      _hover={{ color: "p.700", textDecoration: "underline" }}
    >
      <HStack spacing="xs">
        <span>{displayText}</span>
        {isExternal && <Icon as={FiExternalLink} boxSize={3} />}
      </HStack>
    </Link>
  );
};
